import {Locale} from '@/utils/constants'
import {PricingTabType} from '@/utils/pricing'
import {DEFAULT_HOST, routeTo} from '@/utils/router'
import {filterLegalServicesForResponseToOpposition} from '@/utils/service-request/helpers'
import {AboutUsStatisticName} from '@/utils/statistics/constants'

import {getImageLocale} from '../utils/helpers'

export const getResponseToOppositionContent = (locale: Locale) => {
  const ogImageLocale = getImageLocale(locale)

  return {
    metaTitle: 'opposition-response.meta-title',
    metaDescription: 'opposition-response.meta-desc',
    ogImage: {
      url: `${DEFAULT_HOST}/images/og-images/response-to-opposition-${ogImageLocale}.png`,
      width: 1200,
      height: 627,
      alt: 'Response to opposition - OG image',
    },
    hero: {
      title: 'opposition-response.hero-title',
      subtitle: 'opposition-response.hero-subtitle',
      imageSrc: '/images/hero/document-with-exclamation-mark-and-check-mark.svg',
      imageAlt: 'Document with exclamation mark and check mark',
      secondaryButtonLink: routeTo.pricing(PricingTabType.LegalServices),
    },
    stats: {
      title: 'opposition-response.stats-title',
      description: 'opposition-response.stats-description',
      list: [AboutUsStatisticName.overcomeOppositions, AboutUsStatisticName.coveredCountries],
    },
    solutions: {
      title: 'opposition-response.solutions-title',
      description: 'opposition-response.solutions-description',
      cards: [
        {
          title: 'opposition-response.solution-title-0',
          description: {
            text: 'opposition-response.solution-desc-0',
          },
          imageSrc: '/images/legal-services/document-with-limitation.svg',
          imageAlt: 'Document',
          linkHref: routeTo.limitationOfGoodsAndServices(),
          linkText: 'learn-more-text',
        },
        {
          title: 'opposition-response.solution-title-1',
          description: {
            text: 'opposition-response.solution-desc-1',
          },
          imageSrc: '/images/legal-services/handshake.svg',
          imageAlt: 'Handshake',
          linkHref: routeTo.coexistenceAgreement(),
          linkText: 'learn-more-text',
        },
        {
          title: 'opposition-response.solution-title-2',
          description: {
            text: 'opposition-response.solution-desc-2',
          },
          imageSrc: '/images/legal-services/fountain-pen-with-stars.svg',
          imageAlt: 'Fountain pen with stars',
        },
      ],
    },
    howItWorksSteps: [
      {
        title: 'opposition-response.how-it-works-step-title-0',
        description: 'opposition-response.how-it-works-step-desc-0',
      },
      {
        title: 'opposition-response.how-it-works-step-title-1',
        description: 'opposition-response.how-it-works-step-desc-1',
      },
      {
        title: 'opposition-response.how-it-works-step-title-2',
        description: 'opposition-response.how-it-works-step-desc-2',
      },
    ],
    pricing: {
      description: 'opposition-response.pricing-desc',
      services: filterLegalServicesForResponseToOpposition(),
    },
    ipCasesIds: ['19', '20', '37'],
    faqIds: ['879', '867', '869', '871', '877', '885', '896', '898', '903', '904', '905', '906'],
  }
}
